const getBackgroundcolor = (accentColorDark, attribute=null, themeColors, captions) => {
    let style
    const hexToR = (h) => {return parseInt((cutHex(h)).substring(0,2),16)}
    const hexToG = (h) => {return parseInt((cutHex(h)).substring(2,4),16)}
    const hexToB = (h) => {return parseInt((cutHex(h)).substring(4,6),16)}
    const cutHex = (h) => {return (h.charAt(0)=="#") ? h.substring(1,7):h}
    
    const backgroundColor = hexToR(accentColorDark) + ',' + hexToG(accentColorDark) + ',' + hexToB(accentColorDark)
    
    const id = captions ? 'captions' : String(attribute.id)                

    if(themeColors === 'Dark' || themeColors === 'Kmotion'){
        if(id === '1088' || id === '3d' || id === 'captions') {
            style = 'rgba(' + backgroundColor + ', 0.3)'
        } else if(id === '1522') {
            style = 'rgba(' + backgroundColor + ', 0.6)'
        } else if(id === '1666') {
            style = 'rgba(' + backgroundColor + ', 0.6)'
        } else if(id === '1087' || id === '2d' || id === 'digital') {
            style = 'transparent'
        } else {
            style = 'rgba(' + backgroundColor + ', 1)'
        }
    } else {
        if(id === '1088' || id === '3d' || id === 'captions') {
            style = 'rgba(' + backgroundColor + ', 0.26)'
        } else if(id === '1522') {
            style = 'rgba(' + backgroundColor + ', 0.4)'
        } else if(id === '1666') {
            style = 'rgba(' + backgroundColor + ', 0.54)'
        } else if(id === '1087' || id === '2d' || id === 'digital') {
            style = 'transparent'
        } else {
            style = 'rgba(' + backgroundColor + ', 1)'
        }
    }
    
    return style
}

export default getBackgroundcolor
